import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { UserEndpoint } from '../constants/user-endpoint';
import { MasterDataEndpoint } from '../../../report';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class UserListUploadService {
  constructor(private http: WrapperHttpService) {}

  uploadDocument(language: string, timezone: string, country: string, file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file);

    const url = `${API_URL}${MasterDataEndpoint.Base}${UserEndpoint.User}${
      UserEndpoint.Upload
    }?${getQueryStringFromObject({ timezone, language, country })}`;
    return this.http.post<string>(url, formData);
  }
}
